import {Helmet} from '@dr.pogodin/react-helmet';
import {openConfirmDialog, openDeleteDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {
  useDeleteTireLoadIndexMutation,
  usePostTireLoadIndexSetActiveMutation,
  usePostTireLoadIndexSetInactiveMutation,
} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {DmsDataGrid, handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function TireInventoryLoadIndex() {
  const navigate = useNavigate();

  const [deleteTireLoadIndexApi] = useDeleteTireLoadIndexMutation();
  const [postTireLoadIndexSetActiveApi] = usePostTireLoadIndexSetActiveMutation();
  const [postTireLoadIndexSetInactiveApi] = usePostTireLoadIndexSetInactiveMutation();

  const actionCallback: ActionCallback = ({actionKey, rowId, refreshData}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('edit', 'redirectDetail', () =>
        navigate(composePath(settingsRoutes.tireLoadIndexDetail, {params: {id}}))
      )
      .with('setAsInactive', () =>
        openConfirmDialog({
          onConfirm: () =>
            postTireLoadIndexSetInactiveApi({tireLoadIndexId: id})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
        })
      )
      .with('setAsActive', () =>
        openConfirmDialog({
          onConfirm: () =>
            postTireLoadIndexSetActiveApi({tireLoadIndexId: id})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
        })
      )
      .with('delete', () =>
        openDeleteDialog({
          onConfirm: () =>
            deleteTireLoadIndexApi({tireLoadIndexId: id})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
        })
      );
  };

  return (
    <>
      <Helmet title={i18n.t('entity.tiresInventory.labels.tireLoadIndex')} />
      <SettingsTemplate
        header={{
          title: i18n.t('entity.tiresInventory.labels.tireLoadIndex'),
          actions: [
            {
              type: 'button',
              title: i18n.t('entity.tiresInventory.labels.newTireLoadIndex'),
              onClick: () => navigate(settingsRoutes.tireLoadIndexCreate),
            },
          ],
        }}
        data-testid={testIds.settings.tireLoadIndex('template')}
      >
        <DmsDataGrid
          gridCode="tire-load-index"
          actionCallback={actionCallback}
          data-testid={testIds.settings.tireLoadIndex('datagrid')}
        />
      </SettingsTemplate>
    </>
  );
}
